// extracted by mini-css-extract-plugin
export default {"form":"ProfileEditForm_form__S6ava","form_active":"ProfileEditForm_form_active__P4ubz","title":"ProfileEditForm_title__WJNjz","button":"ProfileEditForm_button__emIAL"};